/**
 * Shared navigation into the Entra signup start route with analytics.
 *
 * Business rule: free/organic signup CTAs fire `signup_cta_clicked` before
 * navigating to `/auth/signup`. Paid campaign claim CTAs use
 * `campaign_cta_clicked` instead and must not call this helper.
 */

import type { NavigateFunction } from 'react-router-dom';
import { AUTH_ROUTES } from '../constants/auth';
import type { SignupCtaId } from '../constants/signupCtaIds';
import { trackSignupCtaClicked } from './marketingTracking';

/**
 * Records signup intent, then navigates to `/auth/signup`.
 *
 * @param navigate - React Router navigate function
 * @param ctaId - Stable CTA identifier for GA4 breakdowns
 * @param options.replace - Defaults to true (matches most public CTAs)
 */
export function beginSignup(
  navigate: NavigateFunction,
  ctaId: SignupCtaId,
  options?: { replace?: boolean },
): void {
  trackSignupCtaClicked(ctaId);
  navigate(AUTH_ROUTES.SIGNUP, { replace: options?.replace ?? true });
}
